<template>
	<div>
		<entity-address
			v-for="(address, index) in addressIds"
			:key="address"
			@input="id => updateAddressIds(id, index)"
			:value="address"
			:field="field"
		></entity-address>
		<entity-address
			:key="address"
			@input="id => updateAddressIds(id, addressIds.length)"
			value="Add new address"
			:field="field"
		>
			<template v-slot:empty>
				<j-button type="tertiary">
					Add New
				</j-button>
			</template>
		</entity-address>
	</div>
</template>

<script>
import EntityAddress from "../../CaseForm/EntityAddress/EntityAddress"
import JButton from "@/components/JButton"
export default {
	components: {
		EntityAddress,
		JButton
	},
	props: {
		/**
		 * Value represents array of `id`
		 */
		value: {
			type: [String, Array]
		},

		/**
		 * Field from schema -- read docs
		 */
		field: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		addressIds() {
			return !this.value || !this.value.length
				? []
				: this.value.map(({ stringValue }) => stringValue)
		}
	},
	methods: {
		updateAddressIds(id, index) {
			console.log("address", id, index)
			let newVal = this.value ? [...this.value] : []
			newVal[index] = { stringValue: id }
			newVal = newVal.filter(address => address.stringValue)
			this.$emit("input", newVal)
		}
	}
}
</script>

<style></style>
